<template>
  <div class="sc-status-widget type-4">
    <div class="sc-status-widget__status">
      <r-title
        :size="44"
        :color="getProgressColor"
      >
        {{ `${getPercentage()}%` }}
      </r-title>
      <r-text type="caption">
        {{ $t("work:traffic-lights") }}
      </r-text>
      <el-progress
        :percentage="getPercentage()"
        :color="getProgressColor"
      />
    </div>
    <div class="sc-status-widget__list">
      <div
        v-for="(item, i) in filteredData"
        :key="item + i"
        class="sc-status-widget__list-item"
      >
        <r-title
          :size="24"
          :color="colors[item.type] || colors.default"
        >
          {{ item.value }}
        </r-title>
        <r-text type="caption">
          {{ $t(item.type) }}
        </r-text>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statusData: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    filteredData() {
      return this.statusData.items || []
    },
    getProgressColor() {
      if (this.getPercentage() > 80) return '#59D64E'
      if (this.getPercentage() > 60) return '#2e93fe'
      if (this.getPercentage() > 40) return '#6f7ad3'
      if (this.getPercentage() > 20) return '#ffac00'

      return '#FF3E3E'
    },
    getTextStyle() {
      return {
        color: `${this.getProgressColor} !important`
      }
    }
  },
  methods: {
    getPercentage() {
      const workCount = this.filteredData
        ? this.filteredData.filter(e => e.type === 'work')[0]
          ? this.filteredData.filter(e => e.type === 'work')[0].value
          : 0
        : 0
      return (
        Number(((workCount * 100) / this.statusData.total).toFixed(0)) || 0
      )
    }
  }
}
</script>

<style lang="scss">
.sc-status-widget {
  &.type-4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    .sc-status-widget__status {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100px;
      margin-bottom: 10px;
      .el-progress {
        width: 100%;
        &-bar {
          padding: 0;
        }
        &__text {
          display: none;
        }
      }
    }
    .sc-status-widget__list {
      display: flex;
      width: calc(100% - 24px);
      height: 100%;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      overflow: hidden;
      overflow-x: auto;
      &-item {
        min-width: calc(25% - 4px);
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-right: 4px;
        overflow: hidden;
        position: relative;
        .r-text.caption-2 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
          text-align: center;
        }
        &:first-child {
          align-items: flex-start;
          .r-text.caption-2 {
            text-align: start;
          }
        }
        &:last-child {
          align-items: flex-end;
          margin-right: 0;
          .r-text.caption-2 {
            text-align: end;
          }
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "work": "Работают",
    "error": "Ошибка",
    "inactive": "Неактивны",
    "work:traffic-lights": "Работающих светофоров"
  },
  "en": {
    "work": "Work",
    "error": "Error",
    "inactive": "Inactive",
    "work:traffic-lights": "Work traffic lights"
  }
}
</i18n>
